import { useQuery } from "@tanstack/react-query";

import { getEventThemeLogos } from "lib/v3/eventThemingApi";
import { getEventId } from "Router/RoutesUtils";
import { useEnvs } from "state/EnvironmentsContext/EnvContext";

type EventThemeLogos = {
  dark_logo?: string | null;
  light_logo?: string | null;
  favicon?: string | null;
};

// Event-level logo/favicon, falls back to the organization ones from envs.
// Event switching reloads the page, so eventId is stable for the app lifetime.
export const useEventThemeLogos = () => {
  const eventId = getEventId();
  const { logo: orgLogo, favicon: orgFavicon } = useEnvs();

  const { data, isLoading } = useQuery(
    ["event-theme-logos", eventId],
    () => getEventThemeLogos(eventId!),
    {
      enabled: !!eventId,
      staleTime: Infinity,
      retry: 1,
      useErrorBoundary: false,
      select: (res): EventThemeLogos => res.data,
    },
  );

  // Hide the logo while the event logos are loading to avoid an org → event flash.
  const isEventLoading = !!eventId && isLoading;

  return {
    logo: isEventLoading ? undefined : data?.dark_logo || orgLogo,
    favicon: isEventLoading ? undefined : data?.favicon || orgFavicon,
    isLoading: isEventLoading,
  };
};
